import { createSelector } from '@ngrx/store';

import join from 'lodash/join';
import map from 'lodash/map';

import { Parser } from '../../../../utils';
import { IDecorationCitation, NumberedCitation } from '../../models';
import { integerToRoman, numberToEncodedLetter } from '../../utils';
import { TEMPLATES, DecoratorsConstant as DC } from '../../const';
import { getCitation } from './get.citations';
import { getIsEditable } from './get.iseditable';

export const getNumberedContent = (props: { heading: string }) =>
  createSelector(
    [getCitation, getIsEditable],
    (citations: IDecorationCitation, isEditable): string => {
      const { references, referencePrefix, prefix, sufix, counterCase } =
        citations;
      const numberCitationString = join(
        map(references, (ref: NumberedCitation, index: number) => {
          const content = new DOMParser().parseFromString(
            ref.citationString,
            'text/html'
          ).body;
          const counter = `${prefix}${
            referencePrefix === 'alphabet'
              ? numberToEncodedLetter(index + 1, counterCase)
              : referencePrefix === 'roman'
              ? integerToRoman(index + 1)
              : index + 1
          }${sufix}`;
          return new Parser().interpolate(TEMPLATES.numberedTemplate, {
            counter,
            citationId: ref.citationId,
            content: content.querySelector(
              `[property="${DC.CITATION_PREF_LABEL}"]`
            ).innerHTML,
            hideShowClass: !isEditable ? DC.HIDE_ACTION_ICONS : '',
            isEditable: isEditable && !ref.isCitationDeleted,
            copyTemplate:
              ref.referencedBy.length > 1 ? TEMPLATES.chevronTemplate : '',
            evidenceLevel: ref.evidenceLevel || '',
            isCitationDeleted: ref.isCitationDeleted ? DC.DISABLE_BLOCK : '',
          });
        }),
        ''
      );

      return `<div class="d-flex static-labelnames" contenteditable="false">
    <h5 class="m-0 tab-heading" contenteditable="false">${props.heading}</h5>
    <span class="numberCircle" contenteditable="false"> ${references.length} </span>
  </div>${numberCitationString}`;
    }
  );
